import { combineReducers } from 'redux'
import types from '../../actions/types'
import { SKILLS } from '../../helpers/onboarding'

export const createSkillReducer = (key) => {

  const active = (state = false, action) => {
    if (action.key !== key) return state

    switch (action.type) {
      case types.ONBOARDING_SKILL_SHOW: return true
      case types.ONBOARDING_SKILL_HIDE:
      case types.ONBOARDING_SKILL_FINISH: return false
      default: return state
    }
  }

  const page = (state = 0, action) => {
    if (action.key !== key) return state

    switch (action.type) {
      case types.ONBOARDING_SKILL_PAGE: return action.page
      case types.ONBOARDING_SKILL_SHOW: return action.page || 0
      case types.ONBOARDING_SKILL_HIDE:
      case types.ONBOARDING_SKILL_FINISH: return 0  // reset
      default: return state
    }
  }

  const started = (state = false, action) => {
    if (action.key !== key) return state

    switch (action.type) {
      case types.ONBOARDING_SKILL_SHOW: return true
      default: return state
    }
  }

  const completed = (state = false, action) => {
    if (action.key !== key) return state

    switch (action.type) {
      case types.ONBOARDING_SKILL_FINISH: return true
      default: return state
    }
  }

  return combineReducers({
    active,
    page,
    completed,
    started,
  })
}

const ret = {}
const values = Object.values(SKILLS)
for (const k in values) {
  const skill = values[k]
  ret[skill.key] = createSkillReducer(skill.key)
}

export default combineReducers(ret)
